:host {
  display: block;
  max-width: 100%;
}

.container {
  gz-tooltip[class='label'] {
    width: 250px;
    display: inline;
    padding-right: calc(2 * var(--spacer));
    line-height: 1;
  }
}

.section,
selected-tags {
  width: 320px;
}

selected-tags {
  padding-left: calc(var(--spacer) * 4);
}

gz-tags-enum-list {
  margin-left: -8px;
}

.endpoint-selected-tag {
  padding: calc(var(--spacer) / 2) 0;
  height: 32px;

  gz-tooltip {
    width: 100%;
  }
}

endpoint-tag {
  border-top: 1px solid var(--chart-101-pressed-dividers);

  &:last-child {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }
}

.title-custom-align {
  padding-bottom: calc(var(--spacer) + 4px);
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-tags-enum-list {
  &::part(listOptions) {
    border: 1px solid var(--chart-101-pressed-dividers);
    margin: 0 var(--spacer);
    border-radius: 4px;
    height: auto;
    min-height: 25px;
    max-height: 288px;
  }

  &::part(listGroup) {
    border: none;
  }
}

gz-text[class='empty-tags'] {
  display: flex;
  align-items: center;
  height: 32px;
  color: var(--chart-300-icon-buttons);
}

.tag-info {
  width: 600px;
}

gz-radio-group[groupName='targets'] {
  width: fit-content;
}
